<template>
  <div class="newStatement">
    <div class="content main-container">
      <Steps :current="current" class="steps">
        <Step :title="item.title" v-for="item in tabList" :key="item.value"></Step>
      </Steps>
      <component :is="componentName" :key="componentName" :ref="componentName" @nextStep="nextStep" @lastStep="lastStep"
        :checkId="checkId" @changeCheckId="changeCheckId" @backStep="backStep"></component>
    </div>
  </div>
</template>

<script>
import statementDetail from "./components/statementDetail.vue" // 对账单详情
import uploadStatement from "./components/uploadStatement.vue" // 上传结算单
import comparativeDetails from "./components/comparativeDetails.vue" // 对比明细
import reconciliationCompleted from "./components/reconciliationCompleted.vue" // 对账完成
import { common } from "@/api/mixins";
export default {
  mixins: [common],
  components: { 
    statementDetail, 
    uploadStatement, 
    comparativeDetails, 
    reconciliationCompleted 
  },
  data() {
    return {
      name: '',
      current: 0,
      componentName: '',
      checkId: '',
      tabList: [
        {
          title: "对账单详情",
          value: "1",
          name: "statementDetail",
        },
        {
          title: "上传结算单",
          value: "2",
          name: "uploadStatement",
        },
        {
          title: "对比明细",
          value: "3",
          name: "comparativeDetails",
        },
        {
          title: "对账完成",
          value: "4",
          name: "reconciliationCompleted",
        },
      ],
    }
  },
  activated() {
    this.getStep()
    this.checkId = this.$route.query.id
  },
  methods: {
    changeCheckId(id) {
      this.checkId = id
    },
    backStep() {
      this.back({query: { id:this.checkId,step: 1 }})
    },
    // 获取对账信息到第几步
    getStep() {
      let step = this.$route.query.step ? this.$route.query.step : '1'
      if (step == '1') {
        this.componentName = 'statementDetail'
        this.current = 0
      } else if (step == '2') {
        this.componentName = 'uploadStatement'
        this.current = 1
      } else if (step == '3') {
        this.componentName = 'comparativeDetails'
        this.current = 2
      } else if (step == '4') {
        this.componentName = 'reconciliationCompleted'
        this.current = 3
      }
    },
    nextStep() {
      this.current += 1
      this.back({query: { id:this.checkId,step: this.current+1}})
    },
    lastStep() {
      this.current -= 1
      this.back({query: { id:this.checkId,step: this.current+1 }})
    }
  }
}
</script>

<style lang="scss" scoped>
@import './newStatement.scss';
</style>